export const responseErrorMessage = (response) => {
	let errorMsg = response?.data?.errors?.replace(/[[\]]/g, '');
	return errorMsg.includes('Error') ? errorMsg : 'Error: ' + errorMsg;
};
